import React, { useState, useEffect } from "react";
import axios from "../../axios";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import {subadminAccessChange,} from "../../utils/functions";
import { RxCross2 } from "react-icons/rx";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  Button,
  ProfileDetailForm,
} from "./CMSElement";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    // minHeight: "87vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
  },
}));

const TermsCondition = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "CMS Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;

  const isDisabled = !canEdit && adminData?.userType === "subAdmin";


  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [inputData, setInputData] = useState("");
  const [contentData, setContentData] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  // const [serviceType, setServiceType] = useState("serviceProvider");

  // Fetch Privacy Policy Data
  const fetchPrivacyPolicy = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`/private/listWebPages?userType=user&pageName=termsAndCondition`);
      setContentData(data?.data);
      setInputData(data?.data?.html || ""); // Update inputData with fetched HTML
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []); // Re-fetch when serviceType changes




  const updatePrivacyPolicy = async () => {
    if (!contentData?._id || !inputData) {
      toast.error("Invalid data. Please ensure all fields are filled.");
      return;
    }

    setIsLoading(true);
    try {
      await axios.put(`/private/updateWebPage/${contentData._id}`, {
        pageName: contentData.pageName,
        html: inputData,
        title: contentData.title,
        userType: contentData.userType,
      });

      toast.success("Content Updated Successfully");
      // Fetch the latest data
      await fetchPrivacyPolicy();
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleErrorResponse = (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "";

    if (status === 422) {
      toast.error(message, { position: toast.POSITION });
    } else if (error?.response?.status === 901) {
      subadminAccessChange(navigate);
      toast.error(`${error.response.data?.message}`, {
        position: "top-right",
      });
    } else if (status === 419) {
      localStorage.clear();
      Cookies.remove("showProfileSidebar");
      setUsers("");
      toast.error(message, { position: toast.POSITION });
      navigate("/");
    } else {
      toast.error(message, { position: toast.POSITION });
    }
  };

  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="common-heading">Terms & Conditions</div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                {!(!canEdit && adminData?.userType === "subAdmin") && (
                <Button
                  type="button"
                  style={{ width: "130px", backgroundColor: "#5088FB" }}
                  // disabled={isLoading || isDisabled}
                  onClick={() => setDeleteModal(true)}
                >
                  Save
                </Button>
                )}
              </div>

            </div>

            <DashboardHeading>
              <Formik
                enableReinitialize
                initialValues={{ inputData }}
                onSubmit={() => updatePrivacyPolicy()}
              >
                {({ values, handleSubmit }) => (
                  <Form style={{ width: "100%" }}>
                    <JoditEditor
                      config={{
                        askBeforePasteFromWord: false,
                        askBeforePasteHTML: false,
                        height: 600,
                        readonly: isDisabled,
                        toolbarStyle: {
                          backgroundColor: "red",
                        },
                      }}
                      value={values.inputData}
                      onBlur={(newContent) => {
                        if (!isDisabled) {
                          setInputData(newContent);
                        }
                      }}
                    />



                    {/* Save Confirmation Modal */}
                    <Modal
                      maxWidth="lg"
                      width="360px"
                      RoundedCorners={true}
                      isOpen={deleteModal}
                      onClose={() => setDeleteModal(false)}
                      backgroundModal={false}
                      backgroundModalContent={false}
                      title={
                        <div>
                          <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                              style={{ cursor: "pointer" }}
                              onClick={() => setDeleteModal(false)}
                            />
                          </div>
                          <p className="profile-section-text">Save</p>
                          <div className="logout-header" style={{ paddingTop: "0px" }}>
                            Are you sure you want to save this? Please confirm that you want to save
                          </div>
                        </div>
                      }
                      content={
                        <div className="logout-button-group">
                          <div
                            className="cancel-button"
                            onClick={() => setDeleteModal(false)}
                          >
                            Cancel
                          </div>

                          <Button
                            type="button"
                            style={{ width: "130px", backgroundColor: "#5088FB" }}
                            disabled={isLoading || isDisabled}
                            onClick={() => {
                              setDeleteModal(false); // Close the modal
                              handleSubmit();        // Trigger Formik submission
                            }}
                          >
                            {isLoading ? "Saving..." : "Save"}
                          </Button>
                        </div>
                      }
                    />
                  </Form>
                )}
              </Formik>

            </DashboardHeading>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsCondition);


